<template>
  <div :class="{'invalid': invalid}">
    <multiselect
        v-model="selectedMarket"
        :placeholder="$t('components.multiselect.marketplace_placeholder')"
        label="text"
        track-by="marketplace_id"
        :options="filteredMarketPlaces"
        deselectLabel=""
        :tagPlaceholder="$t('components.multiselect.tagPlaceholder')"
        selectLabel=""
        selectedLabel=""
        @input="$emit('input', selectedMarket)"
    >
      <template slot="singleLabel" slot-scope="props">
        <span :class="`flag-icon flag-icon-${props.option.value}`"> </span>
        <span class="option__desc mx-2">
        <span>{{ props.option.text }}</span>
      </span>
      </template>

      <template slot="option" slot-scope="props">
        <span :class="`flag-icon flag-icon-${props.option.value}`"> </span>
        <span class="option-title">{{ props.option.text }}</span>
        <span class="mx-2 badge badge-soft-success float-end"
              v-if="props.option.$isDisabled"> {{ $t('components.marketplace_select.available') }}</span>
        <span class="mx-2 badge badge-soft-danger float-end"
              v-else> {{ $t('components.marketplace_select.permission_required') }}</span>
      </template>
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import {mapGetters} from "vuex";

export default {
  name: "MarketPlaceSelectComponent",
  components: {
    Multiselect
  },
  props: {
    value: {
      default: null
    },
    multiple: {
      default: true,
      type: Boolean
    },
    invalid: {
      default: false,
      type: Boolean
    },
    disabledRegions: {
      default: function () {
        return []
      },
      type: Array
    }
  },
  data() {
    return {
      selectedMarket: null,
    }
  },
  computed: {
    ...mapGetters('marketplaces', ['marketplaces']),
    filteredMarketPlaces() {
      const marketplaces = [...this.marketplaces]

      marketplaces.forEach(item => {
        this.disabledRegions.forEach(reg => {
          item.$isDisabled = item.region === reg
        })
      })

      marketplaces.sort(x => !x.$isDisabled ? -1 : 1)
      return marketplaces
    }
  }
}
</script>

<style scoped>
.option-title {
  margin-left: 6px;
}

.invalid /deep/ .multiselect__tags {
  border-color: #f46a6a !important;
}

.market-option:disabled {
  opacity: 0.6;
  pointer-events: none;
}

/deep/ .multiselect__option--disabled {
  background-color: #eff2f7;
  opacity: 1;
}
</style>